import React, { useState } from 'react'
import { Button, Card, CardContent, Divider, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import Input from '../../../components/forms/Input'
import Select from '../../../components/forms/Select'
import DtoSandreCode from '../../../referencial/dto/DtoSandreCode'
import { getSandreList } from 'utils/StoreUtils'
import AdministrationAction from 'administration/actions/AdministrationAction'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'

const emptyFilter = {
    searchValue: '',
    resourceType: undefined,
}

const RestrictionsFilterPanel = ({ onValidate = () => {} }) => {
    const [tmpFilter, setTmpFilter] = useState(emptyFilter)

    const {
        sandreCodes,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)

    const agriTypeRestriction = useApplicationSetting('agriTypeRestriction', setting => setting ? parseInt(setting) : 1)

    const dispatch = useDispatch()

    const resetFilters = () => {
        setTmpFilter(emptyFilter)
        onValidate(emptyFilter)
    }
    const { searchValue, resourceType } = tmpFilter

    return (
        <Card>
            <CardContent>
                <Grid container spacing={1}>
                    <Grid size={3}>
                        <Select
                            label={i18n.division}
                            value={agriTypeRestriction}
                            options={[{
                                value: 1,
                                label: i18n.droughtSectors,
                            }, {
                                value: 2,
                                label: i18n.managementUnits,
                            }]}
                            onChange={(v) => dispatch(AdministrationAction.updateSieauParameters([{ parameter: 'agriTypeRestriction', value: `${v}` }]))}
                            noNullValue
                        />
                    </Grid>
                    <Grid size={12}>
                        <Divider/>
                    </Grid>
                    <Grid size={3}>
                        <Input
                            containerClassName='no-margin'
                            title={ i18n.search }
                            value={ searchValue }
                            onChange={(v) => setTmpFilter({ ...tmpFilter, searchValue: v })}
                            onEnterKeyPress={() => onValidate(tmpFilter)}
                        />
                    </Grid>
                    <Grid size={3}>
                        <Select
                            label={i18n.type}
                            value={resourceType}
                            options={getSandreList(sandreCodes, 'PREL_AGRI.TYPE_PRELEVEMENT')}
                            keyLabel='labelWithCode'
                            onChange={(v) => setTmpFilter({ ...tmpFilter, resourceType: v })}
                            clearFunction
                        />
                    </Grid>
                    <Grid offset={6}/>
                    <Grid container size={12} justifyContent='flex-end' spacing={1}>
                        <Button variant='outlined' onClick={resetFilters}>
                            {i18n.reinit}
                        </Button>
                        <Button variant='contained' onClick={() => onValidate(tmpFilter)}>
                            {i18n.search}
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

RestrictionsFilterPanel.propTypes = {
    onValidate: PropTypes.func.isRequired,
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
}

export default RestrictionsFilterPanel